import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page--limited" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "p-d-flex p-jc-end" }
const _hoisted_4 = { class: "p-d-flex" }
const _hoisted_5 = { class: "p-d-flex" }
const _hoisted_6 = { class: "p-d-flex" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "p-d-flex p-ai-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("strong", { class: "p-mx-3" }, "+", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("strong", { class: "p-mx-3" }, "=", -1)
const _hoisted_11 = { class: "p-fluid p-mt-3" }
const _hoisted_12 = { class: "p-text-center" }
const _hoisted_13 = { class: "card" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_ChipFilters = _resolveComponent("ChipFilters")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_ShiftToText = _resolveComponent("ShiftToText")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_CurrencyText = _resolveComponent("CurrencyText")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_OrderTable = _resolveComponent("OrderTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageHeader, {
      title: _ctx.$t(
        'billing_supplier.title',
        { name: _ctx.entity?.business_name || '...' }
      ),
      showSave: false,
      showDelete: false
    }, null, 8, ["title"]),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createVNode(_component_ChipFilters, {
            from: _ctx.from,
            to: _ctx.to,
            zoneName: _ctx.zoneName
          }, null, 8, ["from", "to", "zoneName"])
        ])
      ]),
      _createVNode(_component_DataTable, {
        class: "p-mt-3",
        value: _ctx.shifts,
        loading: _ctx.shiftsAreLoading,
        responsiveLayout: "scroll"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ColumnGroup, { type: "header" }, {
            default: _withCtx(() => [
              _createVNode(_component_Row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    header: "Fascia oraria",
                    rowspan: 2
                  }),
                  _createVNode(_component_Column, {
                    header: "Lunedì - Venerdì",
                    colspan: 2
                  }),
                  _createVNode(_component_Column, {
                    header: "Sabato",
                    colspan: 2
                  }),
                  _createVNode(_component_Column, {
                    header: "Domenica",
                    colspan: 2
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_Row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, { header: "Qtà" }),
                  _createVNode(_component_Column, { header: "Costo" }),
                  _createVNode(_component_Column, { header: "Qtà" }),
                  _createVNode(_component_Column, { header: "Costo" }),
                  _createVNode(_component_Column, { header: "Qtà" }),
                  _createVNode(_component_Column, { header: "Costo" })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Fascia oraria",
            style: { minWidth: '180px' }
          }, {
            body: _withCtx(({data: { shift }}) => [
              _createVNode(_component_ShiftToText, { shift: shift }, null, 8, ["shift"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Qtà",
            field: "weekday_range1_shifts_qty",
            style: { minWidth: '100px' }
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_InputText, {
                type: "number",
                modelValue: data.weekday_range1_shifts_qty,
                "onUpdate:modelValue": ($event: any) => (data.weekday_range1_shifts_qty = $event),
                class: "small_input"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Lunedì - Venerdì",
            style: { minWidth: '180px' }
          }, {
            body: _withCtx(({data}) => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_CurrencyText, {
                  modelValue: data.weekday_range1_cost
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Qtà",
            field: "weekday_range2_shifts_qty",
            style: { minWidth: '100px' }
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_InputText, {
                type: "number",
                modelValue: data.weekday_range2_shifts_qty,
                "onUpdate:modelValue": ($event: any) => (data.weekday_range2_shifts_qty = $event),
                class: "small_input"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Sabato",
            style: { minWidth: '180px' }
          }, {
            body: _withCtx(({data}) => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_CurrencyText, {
                  modelValue: data.weekday_range2_cost
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Qtà",
            field: "weekday_range3_shifts_qty",
            style: { minWi100th: '180px' }
          }, {
            body: _withCtx(({data}) => [
              _createVNode(_component_InputText, {
                type: "number",
                modelValue: data.weekday_range3_shifts_qty,
                "onUpdate:modelValue": ($event: any) => (data.weekday_range3_shifts_qty = $event),
                class: "small_input"
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            header: "Domenica",
            style: { minWidth: '180px' }
          }, {
            body: _withCtx(({data}) => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_CurrencyText, {
                  modelValue: data.weekday_range3_cost
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "loading"])
    ]),
    _createElementVNode("section", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_FloatLabel, {
          label: _ctx.$t('billing_supplier.total_shifts')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InputNumber, {
              modelValue: _ctx.total_shifts_amount,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.total_shifts_amount = $event)),
              mode: "currency",
              currency: "EUR",
              locale: "it-IT"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _hoisted_9,
        _createVNode(_component_FloatLabel, {
          label: _ctx.$t('billing_supplier.total_orders')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_InputNumber, {
              modelValue: _ctx.total_sys_amount,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.total_sys_amount = $event)),
              mode: "currency",
              currency: "EUR",
              locale: "it-IT"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _hoisted_10,
        _createElementVNode("strong", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('billing_supplier.total')) + " ", 1),
          _createVNode(_component_CurrencyText, { "model-value": _ctx.total }, null, 8, ["model-value"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_FloatLabel, {
          label: _ctx.$t('billing_supplier.note_label')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Textarea, {
              modelValue: _ctx.note,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.note = $event)),
              placeholder: _ctx.$t('billing_supplier.note_placeholder'),
              cols: "35"
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_Button, {
          class: "p-button-lg",
          icon: "pi pi-check-circle",
          label: _ctx.$t('billing_supplier.process'),
          onClick: _ctx.onProcessClick,
          loading: _ctx.isLoading
        }, null, 8, ["label", "onClick", "loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("h5", null, _toDisplayString(_ctx.$t('billing_supplier.table.title')), 1),
      _createVNode(_component_OrderTable, {
        isLoading: _ctx.ordersAreLoading,
        value: _ctx.orders,
        totalRecords: _ctx.ordersTotalRecords,
        onPage: _ctx.loadUnprocessedOrders
      }, {
        cols: _withCtx(() => [
          _createVNode(_component_Column, {
            class: "p-text-right",
            field: "est_price",
            header: "Costo",
            headerClass: "column-header-right",
            style: {"min-width":"6rem"}
          }, {
            body: _withCtx(({data: { est_cost }}) => [
              _createVNode(_component_CurrencyText, { modelValue: est_cost }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            class: "p-text-right",
            field: "est_price_extra1_value",
            header: "Costo extra",
            headerClass: "column-header-right",
            style: {"min-width":"6rem"}
          }, {
            body: _withCtx(({data: { est_cost_extra1_value }}) => [
              _createVNode(_component_CurrencyText, { modelValue: est_cost_extra1_value }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            class: "p-text-right",
            field: "tot_est_price",
            header: "Costo totale",
            headerClass: "column-header-right",
            style: {"min-width":"6rem"}
          }, {
            body: _withCtx(({data: { tot_est_cost }}) => [
              _createVNode(_component_CurrencyText, { modelValue: tot_est_cost }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["isLoading", "value", "totalRecords", "onPage"])
    ])
  ]))
}